var map = {
	"./1-bn.png": "b854",
	"./10-bn.png": "72b6",
	"./11-bn.png": "ea84",
	"./12-bn.png": "a132",
	"./2-bn.png": "4d3c",
	"./4-bn.png": "5711",
	"./5-bn.png": "f3f6",
	"./7-bn.png": "8f19",
	"./9-bn.png": "b96d",
	"./CAT_SANOFIAVENTIS-small.png": "238f",
	"./CAT_SANOFIAVENTIS.jpg": "e413",
	"./Covid-19.jpg": "ca98",
	"./Laboratorio-envios.png": "7fc5",
	"./ProductoSinImagen.jpg": "7b64",
	"./ProductoSinImagen2.jpg": "996c",
	"./S-analisis-clinicos.png": "a1b7",
	"./S-aplicaciones.png": "e3ce",
	"./S-enfermeria.png": "19fb",
	"./S-medicina-especialidad.png": "4ff7",
	"./S-servicios-medicos.png": "a1ff",
	"./Sedes-CDA.png": "010d",
	"./Sedes-Farmacia.png": "66f7",
	"./Sedes-LAB.png": "cd74",
	"./Ups.png": "acfc",
	"./abbott-small.png": "d45a",
	"./abbott.jpg": "8aed",
	"./abbvie-small.png": "f157",
	"./abbvie.jpg": "c062",
	"./analisis-landing.png": "857e",
	"./aplicaciones-foto1.png": "b6fd",
	"./aplicaciones-foto2.png": "1d19",
	"./back1.jpg": "0e07",
	"./back2.jpg": "167e",
	"./background-covid.png": "f6ef",
	"./bago-small.png": "e831",
	"./bago.jpg": "6edf",
	"./bak3.jpg": "63a9",
	"./bandera-header.png": "cc96",
	"./banner-1.png": "f94a",
	"./banner-2.png": "8ff2",
	"./banner-contacto.png": "7ee6",
	"./banner-covid.png": "937c",
	"./banner-home.jpg": "a04a",
	"./banner-nosotros.jpg": "a0ab",
	"./banner-roche.png": "6e9a",
	"./banner-sedes.png": "4d8d",
	"./banner-servicios (1).jpg": "5aa6",
	"./banner-servicios.jpg": "9bd8",
	"./banner-web-1.jpg": "3e1d",
	"./banner-web-1.png": "2882",
	"./banner-web-2.jpg": "658f",
	"./banner-web-3.jpg": "25ab",
	"./banner-web-3.png": "606e",
	"./banner-web-4.jpg": "be64",
	"./banner-web.2.png": "eb11",
	"./banner.png": "ec24",
	"./blanco.png": "6a47",
	"./cat_sanofiaventis-small.jpg": "1f37",
	"./cat_sanofiaventis-small.png": "2bbb",
	"./cat_sanofiaventis.jpg": "8748",
	"./controlados.png": "22a7",
	"./coporativo-informe.png": "e603",
	"./coporativo-representacion-marca.png": "8cb2",
	"./corporativo-atencion-primaria.png": "3889",
	"./corporativo-insumos.png": "0d54",
	"./corporativo-seg-ocupacional.png": "45e6",
	"./corporativo.png": "59f2",
	"./eliminar.png": "d907",
	"./empresas-landing.png": "646e",
	"./enfermeria-foto1.png": "ff71",
	"./enfermeria-foto2.png": "d092",
	"./fb-blanco-footer.png": "254c",
	"./fb-naranja-header.png": "ac7e",
	"./fondo-footer.png": "29bc",
	"./grupo-inno.jpg": "9013",
	"./icono-1.png": "cff6",
	"./icono-2.png": "c740",
	"./icono-3.png": "4753",
	"./icono-4.png": "e512",
	"./icono-bag.png": "3ac2",
	"./icono-inicio.png": "06c6",
	"./icono-medicina.png": "d958",
	"./ig-blanco-header.png": "d55c",
	"./ig-naranja-header.png": "c3d2",
	"./lab-aplicaciones.png": "1e9b",
	"./llamada-naranja-header.png": "3c7e",
	"./llamadas.png": "8ee7",
	"./login_img.png": "11d7",
	"./logo-blanco-innofarm.png": "15e9",
	"./logo-blanco-innofarm2.png": "d213",
	"./logo-envíos-aplicaciones.png": "c0e4",
	"./logo.png": "cf05",
	"./logout.png": "bc8c",
	"./megalabs-small.png": "d3b7",
	"./megalabs.jpg": "fb79",
	"./merck-small.png": "ccba",
	"./merck.png": "eb86",
	"./nosotros-clientes.png": "1209",
	"./nosotros-ecuador.png": "8174",
	"./nosotros-pedidos.png": "3f6e",
	"./pacientes.png": "10e0",
	"./pfizer-small.png": "69c3",
	"./pfizer.jpg": "0af3",
	"./psicotropicos.png": "3233",
	"./roche-small.png": "ab53",
	"./roche.jpg": "e174",
	"./tw-blanco-footer.png": "733a",
	"./tw-naranja-header.png": "694f",
	"./wapp-naranja-header.png": "0d3d",
	"./whatsapp-verde.png": "e2b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";